import APIService from '../api';

export default class FlagService extends APIService {
  getFlags() {
    return this.get('/feature-flag');
  }
}
